import axios from 'axios'
// 引入提示消息组件
import domMessage from './onceMessage'  // 引入方法
import Router from '../../router' // Router===this.$router
import qs from 'qs'
// 环境判断设置baseURL
//let baseURL = process.env.NODE_ENV === 'development' ? 'dev.com' : process.env.NODE_ENV === 'production' ? 'pro.com' : 'test.com'\
//http://47.122.5.202:9001/masjhcy/fdjJsWebapi
const baseURL = window.baseURL;
const TOKEN_KEY = 'access_token'
const messageOnce = new domMessage()
const REGRESH_TOKEN_KEY = 'refresh_token'
const getToken = () => localStorage.getItem(TOKEN_KEY);
// const setToken = (token, params = {}) => {
//  localStorage.setItem(token ? token:TOKEN_KEY, params)
// }

// 给请求头添加 access_token
const setHeaderToken = (isNeedToken) => {
	const TOKEN = localStorage.getItem('access_token');
	if (isNeedToken) { // api 请求需要携带 access_token 	
		if (!TOKEN) {
			messageOnce.error('获取用户信息失败，请重新登陆！');
			return Router.push('/login')
		}
		return axios.defaults.headers.common.Authorization = `Bearer ${TOKEN}`;
	}
}
// 定义请求头 使用JSON格式
axios.defaults.baseURL = baseURL // Default base path
axios.defaults.headers.post['Content-Type'] = 'application/json;charSet=UTF-8'
axios.defaults.headers.get['Content-Type'] = 'application/json;charSet=UTF-8'
axios.defaults.headers.put['Content-Type'] = 'application/json;charSet=UTF-8'
axios.defaults.headers.delete['Content-Type'] = 'application/json;charSet=UTF-8'
axios.defaults.headers.patch['Content-Type'] = 'application/json;charSet=UTF-8'
axios.defaults.timeout = 50000; // 5min
let isRefreshing = false // 标记是否正在刷新 token
let requests = [] // 存储待重发请求的数组
// 添加响应拦截器
axios.interceptors.response.use((response) => {
	//console.log('当前响应代码suc:',response)
	return response
}, (error) => {
	if (!error.response) {
		return Promise.reject(error)
	}
	if (error.response.status === 401) {
		messageOnce.alert({
			message: '登录信息不存在或已过期',
			title: '温馨提示',
			confirmButtonText: '确定',
			showClose: false,
			type: 'warning',
			callback: () => {
				localStorage.clear();
				return Router.push('/login');
			}
		})

	}
	/* 
		if (error.response.status === 401) {
			console.log('request 刷新token');
			const { config } = error
			if (!isRefreshing) {
				isRefreshing = true
				return refreshToken().then(res=> {
					if(res.data.code!=200) {
						//Message.error('抱歉，您的登录状态已失效，请重新登录');
						localStorage.clear();
						return Router.push('/login');
					}
					const { access_token } = res.data.rows;
					setToken(access_token)
					config.headers.Authorization = `Bearer ${access_token}`
					// token 刷新后将数组的方法重新执行
					requests.forEach((cb) => cb(access_token))
					requests = [] // 重新请求完清空
					return axios(config)
				}).catch(err => {
					//console.log('抱歉，您的登录状态已失效，请重新登录！')
					localStorage.clear();
					Message.error('抱歉，您的登录状态已失效，请重新登录');
					return Promise.reject(err)
				}).finally(() => {
					isRefreshing = false
				})
			} else {
				// 返回未执行 resolve 的 Promise
				return new Promise(resolve => {
					// 用函数形式将 resolve 存入，等待刷新后再执行
					requests.push(token => {
						config.headers.Authorization = `Bearer ${token}`
						resolve(axios(config))
					})  
				})
			}
		}
		 */
	return Promise.reject(error)
})



export default {
	/**
	* get 方法封装
	* @param url
	* @param params
	* @param  isNeedToken 
	* @returns {Promise}
	*/
	// 有些接口并不需要用户授权使用，则无需携带 access_token；默认不携带，需要传则设置第三个参数为 true
	get(url, params = {}, isNeedToken = false) {
		setHeaderToken(isNeedToken);
		return new Promise((resolve, reject) => {
			axios.get(url, {
				params: params,
				paramsSerializer: params => {
					return qs.stringify(params, { indices: false })
				}
			}).then(res => {
				resolve(res.data)
			}).catch(err => {
				reject(err)
			})
		})
	},

	/**
	* post
	* @param url
	* @param params
	* @param  isNeedToken 
	* @returns {Promise}
	*/
	post(url, params = {}, isNeedToken = false) {
		setHeaderToken(isNeedToken);
		return new Promise((resolve, reject) => {
			axios.post(url, params)
				.then(res => {
					resolve(res.data)
				}, err => {
					reject(err)
				})
		})
	},

	/**
	* delete 方法封装
	* @param url
	* @param params
	* @param  isNeedToken 
	* @returns {Promise}
	*/

	delete(url, params = {}, isNeedToken = false) {
		setHeaderToken(isNeedToken);
		return new Promise((resolve, reject) => {
			axios.delete(url, params).then(res => {
				resolve(res.data)
			}).catch(err => {
				reject(err)
			})
		})
	},

	/**

	* put 方法封装

	* @param url
	* @param params
	* @returns {Promise}
	*/

	put(url, params = {}, isNeedToken = false) {
		setHeaderToken(isNeedToken);
		return new Promise((resolve, reject) => {
			axios.put(url, params).then(res => {
				resolve(res.data)
			}).catch(err => {
				reject(err)
			})
		})
	},
	down(url, params = {}, isNeedToken = false) {
		setHeaderToken(isNeedToken);
		return new Promise((resolve, reject) => {
			axios.get(url, {
				params: params,
				responseType: 'blob', // import 设置响应类型
			}).then(res => {
				resolve(res)
			}).catch(err => {
				reject(err)
			})
		})
	},
}
